var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBox}},[_c('use',{attrs:{"href":_vm.link}})])
}
var staticRenderFns = []

export { render, staticRenderFns }